import { useSearch } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { useDocumentTitle } from '#/shared/lib/document-title'

import { LEADS_DEFAULT_TAB, LEADS_TAB_KEYS } from './tabs'
import type { LeadsTabKey } from './tabs'

const TAB_LABEL_KEY: Record<LeadsTabKey, string> = {
  [LEADS_TAB_KEYS.NEW_LEADS]: 'header.tabs.newLeads',
  [LEADS_TAB_KEYS.ARCHIVED]: 'header.tabs.archived',
}

function resolveTabKey(value: unknown): LeadsTabKey {
  if (typeof value !== 'string') return LEADS_DEFAULT_TAB
  return value in TAB_LABEL_KEY ? (value as LeadsTabKey) : LEADS_DEFAULT_TAB
}

export function useLeadsDocumentTitle(): void {
  const { t } = useTranslation()
  const raw: Record<string, unknown> = useSearch({ strict: false })
  const tab = resolveTabKey(raw['status'])
  useDocumentTitle(t('documentTitle.leads'), t(TAB_LABEL_KEY[tab]))
}
